import { memo } from 'react';

import { Flex, Typography } from 'antd';

import styles from './styles.module.scss';

const { Title } = Typography;

function RuleDefinition({ definition }) {
  return (
    <Flex vertical={true} gap="small">
      <Title level={5}>Rule Definition (Auto generated)</Title>
      <Flex align="center" justify="center" className={styles['rule-definition']}>
        {definition}
      </Flex>
    </Flex>
  );
}

export default memo(RuleDefinition);
